import { useAuth } from '@/services/user/Auth0UserProvider'
import { useRouter } from 'vue-router'
import store from '@/services/store'
import storeFabric from '@/services/store/StoreFabric'
import { SHOW_MARKER_SETTING } from '@/services/const'

export default function useLogout() {
  const { logout } = useAuth()
  const { push } = useRouter()

  const logoutAndRedirect = () => {
    logout()

    // LocalStorageクリア
    storeFabric.clean(SHOW_MARKER_SETTING)

    // Vuexストアクリア
    store.commit('clearMyOffice')
    store.commit('clearSelectableOperationOffices')
    store.commit('clearSelectedOperationOffice')
    store.commit('clearSearchedOperationOffices')

    push({ path: '/' })
  }

  return {
    logoutAndRedirect,
  }
}
